import { RingLoader, toast, useLocalization } from '@magicdoorinc/ui';
import { createEffect, createMemo, createSignal, Show } from 'solid-js';
import GiftBoxImg from '~/assets/images/referral/giftBox.png';
import { IconSend } from '~/components/common/SendEmail/Icons';
import { useReferral } from '~/contexts/global';
import { useDeviceDetect } from '~/hooks/usedeviceDetect';
import { ReferralModal } from './ReferralModal';
export const ReferralCard = () => {
  const { t } = useLocalization();

  const { referralLink, refetch } = useReferral();
  const { isMobileView } = useDeviceDetect();

  const [showReferralModal, setShowReferralModal] = createSignal<boolean>(false);
  const [beforeText, setBeforeText] = createSignal<string>();
  const [afterText, setAfterText] = createSignal<string>();
  const amount = '$500';
  const textWithMarker = createMemo(() => t('referral.reward', { amount: '%%AMOUNT%%' }));
  createEffect(() => {
    const [before, after] = textWithMarker().split('%%AMOUNT%%');
    setBeforeText(before);
    setAfterText(after);
  });

  const handleShowModal = async () => {
    if (referralLink()?.url) {
      setShowReferralModal(true);
    } else {
      try {
        await refetch();
        setShowReferralModal(true);
      } catch {
        toast.error(t('Failed to obtain the invitation link'));
      }
    }
  };
  return (
    <>
      <Show
        when={isMobileView()}
        fallback={
          <div class="relative mx-auto mb-5 h-[173px] w-10/12">
            <img class="absolute left-1/2 top-0 z-10 w-[142px] -translate-x-1/2" src={GiftBoxImg} alt="GiftBoxImg" />
            <div
              class="absolute bottom-0 h-[129px] w-full rounded-xl px-3"
              style={{
                background: 'linear-gradient(180deg, #FFF6D3 0%, #FFEC9E 100%)',
              }}>
              <div class="mt-8 text-center text-sm font-medium text-[#BC5E1B]">
                {beforeText()}
                <span class="text-xl font-bold text-[#E66000]">{amount}</span>
                {afterText()}
              </div>
              <div
                onClick={handleShowModal}
                class="mx-auto mt-1.5 flex h-[32px] w-[124px] cursor-pointer items-center justify-center gap-1 rounded-full border border-[#FFA268] text-white"
                style={{
                  background: 'linear-gradient(184.23deg, #FF8A37 2.85%, #E66000 95.99%)',
                }}>
                <Show when={!referralLink.loading} fallback={<RingLoader size={16} color="#FFF" />}>
                  <IconSend class="size-4" />
                  <span class="text-xs font-bold">{t('Invitation')}</span>
                </Show>
              </div>
            </div>
          </div>
        }>
        <div
          onClick={handleShowModal}
          class="relative mx-auto mb-3 flex w-10/12 cursor-pointer items-center gap-2 overflow-hidden rounded-xl px-2.5 py-2"
          style={{
            background: 'linear-gradient(180deg, #FFF6D3 0%, #FFEC9E 100%)',
          }}>
          <img
            class="pointer-events-none absolute inset-y-0 right-0 h-full w-20 select-none object-cover object-right opacity-30"
            style={{
              '-webkit-mask-image': 'linear-gradient(270deg, #000 0%, transparent 100%)',
              'mask-image': 'linear-gradient(270deg, #000 0%, transparent 100%)',
            }}
            src={GiftBoxImg}
            alt=""
          />
          <div class="relative flex-1 text-xs font-medium leading-tight text-[#BC5E1B]">
            {beforeText()}
            <span class="font-bold text-[#E66000]">{amount}</span>
            {afterText()}
          </div>
          <div
            class="relative flex size-7 shrink-0 items-center justify-center rounded-full border border-[#FFA268] text-white"
            style={{
              background: 'linear-gradient(184.23deg, #FF8A37 2.85%, #E66000 95.99%)',
            }}>
            <Show when={!referralLink.loading} fallback={<RingLoader size={14} color="#FFF" />}>
              <IconSend class="size-3.5" />
            </Show>
          </div>
        </div>
      </Show>
      <ReferralModal url={referralLink()?.url || ''} open={showReferralModal()} onClose={() => setShowReferralModal(false)} />
    </>
  );
};
